import { Theme } from './Theme'

export const normal = (theme: Theme) => [1, 'solid', theme.border.normal]
export const dim    = (theme: Theme) => [1, 'solid', theme.border.dim]